/** Family Tree Maker tree4 — aligned with tree2/tree3 site patterns */
export const COMPANY_NAME = 'Opulence Technologies';
export const COMPANY_ADDRESS = '212 N. 2nd Street, STE 100, Richmond, KY 40475';
export const SUPPORT_EMAIL = 'support@familytreemakerhelpss.com';

export const SUPPORT_PHONE_DISPLAY = '+18444993050';
export const SUPPORT_PHONE_TEL = '+18444993050';

export const SITE_DOMAIN = 'familytreemakerhelpss.com';
export const SITE_URL = 'https://familytreemakerhelpss.com/';
